import React, {Component} from 'react';

class InfoTooltip extends Component {

    constructor(props) {
        super(props);
        
        this.tooltipRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.for) {
            const elementToWatch = document.querySelector(this.props.for);
            
            if(elementToWatch){
                elementToWatch.addEventListener('mouseenter', this.showTooltip);
                elementToWatch.addEventListener('mouseleave', this.hideTooltip);
            }
        }        
    }

    componentWillUnmount() {
        
        if (this.props.for) {
            const elementToWatch = document.querySelector(this.props.for);
            if(elementToWatch){
                elementToWatch.removeEventListener('mouseenter', this.showTooltip);
                elementToWatch.removeEventListener('mouseleave', this.hideTooltip);
            }
        }
    }


    showTooltip = (event) => {
        const tooltip = this.tooltipRef.current;
        
        if(tooltip){
            tooltip.classList.add('hover');
        }
    }

    hideTooltip = () => {
        const tooltip = this.tooltipRef.current;
        if(tooltip){
            tooltip.classList.remove('hover');
        }
    }

    render() {
        const showIcon = this.props.noIcon ? false : true;
        const classes = this.props.position ? `tooltip-container positioned ${this.props.position}` : 'tooltip-container';

        return (
            <div ref={this.tooltipRef} className={classes}>
            {showIcon && <div className="info-icon">
                <i className='material-icons btn-info-popup'>info_outline</i>
            </div>}
            <div className="tooltip-message">
                {this.props.message}
            </div>
            </div>
        );
    }
};

export default InfoTooltip;
